/*
 * @FilePath     : /es-package/packages/es-mpx-storage/lib/storage.web.js
 * @Author       : LiYang
 * @Date         : 2022-02-08 16:56:42
 * @LastEditTime : 2022-02-08 20:36:09
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import creator from './creator'

export default {
  local: creator(window.localStorage),
  session: creator(window.sessionStorage),
}